import { getInputProps } from '@/component/Table/filter/util';
import { useTexts } from '@/feature/lang';
import { Input } from '../../Form';
import type { ColumnFilterProps } from '../types';

export const DefaultColumnFilter = ({ column, layout }: ColumnFilterProps) => {
  const texts = useTexts();
  return (
    <Input
      value={column.getFilterValue() || ''}
      name={column.id}
      onChange={(e) => {
        column.setFilterValue(e.target.value || undefined); // Set undefined to remove the filter entirely
      }}
      {...getInputProps(column, layout, texts)}
    />
  );
};
